
export function QualitySection() {
  const features = [
    {
      icon: 'ri-sun-line',
      title: 'UV-beständiger Druck',
      description: 'Langlebige Farben durch modernste UV-resistente Druckverfahren für jahrelange Brillanz.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Wetterfeste Materialien',
      description: 'Hochwertige, witterungsbeständige Stoffe für optimale Performance bei jedem Wetter.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Nachhaltige Produktion',
      description: 'Umweltfreundliche Herstellungsprozesse und recycelbare Materialien für eine grünere Zukunft.'
    },
    {
      icon: 'ri-ruler-2-line',
      title: 'Maßgeschneiderte Lösungen',
      description: 'Individuelle Anfertigung nach Ihren exakten Spezifikationen und Corporate Design-Vorgaben.'
    },
    {
      icon: 'ri-timer-line',
      title: 'Express-Service',
      description: 'Kurze Produktionszeiten ohne Qualitätsverlust – auch bei dringenden Terminen zuverlässig.'
    },
    {
      icon: 'ri-truck-line',
      title: 'EU-weiter Versand',
      description: 'Schnelle und sichere Lieferung in ganz Deutschland und Europa mit zuverlässigen Partnern.'
    }
  ];

  return (
    <section className="py-20 bg-zinc-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Warum Horizon Signage?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Ihre Vorteile bei der Zusammenarbeit mit dem führenden Anbieter 
            für professionelle Promotion-Fahnen
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-zinc-700 rounded-2xl p-8 hover:bg-zinc-600 transition-all duration-300 transform hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-2xl text-zinc-800`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-4 group-hover:text-gray-100 transition-colors">
                {feature.title}
              </h3>
              <p className="text-gray-300 leading-relaxed group-hover:text-gray-200 transition-colors">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 max-w-4xl mx-auto shadow-xl">
            <h3 className="text-2xl font-bold text-zinc-800 mb-4">
              Überzeugen Sie sich von unserer Qualität
            </h3>
            <p className="text-gray-600 text-lg mb-6">
              Fordern Sie noch heute Ihr unverbindliches Angebot an und erleben Sie 
              den Unterschied professioneller Promotion-Fahnen.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/kontakt"
                className="inline-flex items-center justify-center px-8 py-4 bg-zinc-800 text-white font-semibold rounded-lg hover:bg-zinc-900 transition-colors whitespace-nowrap"
              >
                Kostenlose Beratung
                <i className="ri-phone-line ml-2"></i>
              </a>
              <a
                href="/produkte"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-zinc-800 text-zinc-800 font-semibold rounded-lg hover:bg-zinc-800 hover:text-white transition-colors whitespace-nowrap"
              >
                Produktkatalog ansehen
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
